export default __webpack_public_path__ + "static/media/SM-Ex-3.f3b62688.png";